export const palette = {
  primary: {
    main: '#0D61FF',
    light: '#D1E1FF',
    dark: '#0A4ECC',
    contrastText: '#FFFFFF',
  },

  purple: {
    main: '#7C3AED',
    light: '#EDE9FE',
    dark: '#5B21B6',
    contrastText: '#FFFFFF',
  },

  secondary: {
    main: '#091B35',
    light: '#3D4F6B',
    dark: '#050E1C',
    contrastText: '#FFFFFF',
  },

  success: {
    main: '#27AE60',
    light: '#D4EDDA',
    dark: '#1E8C4D',
    contrastText: '#FFFFFF',
  },

  warning: {
    main: '#F2994A',
    light: '#FDEBD0',
    dark: '#C77A3B',
    contrastText: '#FFFFFF',
  },

  error: {
    main: '#EB5757',
    light: '#FDEDED',
    dark: '#D32F2F',
    contrastText: '#FFFFFF',
  },

  info: {
    main: '#F2C94C',
    light: '#FFF8E1',
    dark: '#C2A13D',
    contrastText: '#091B35',
  },

  text: {
    primary: '#091B35',
    secondary: '#666666',
    disabled: '#9A9B9E',
  },

  divider: '#E0E0E0',

  background: {
    default: '#FFFFFF',
    paper: '#FFFFFF',
    subtle: '#FAFAFA',
    alternate: '#F2F2F8',
  },

  grey: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#E0E0E0',
    300: '#BDBDBD',
    400: '#9A9B9E',
    500: '#828282',
    600: '#666666',
    700: '#555555',
    800: '#333333',
    900: '#091B35',
  },

  action: {
    hover: '#D1E1FF',
    selected: '#D1E1FF',
    focus: '#D1E1FF',
  },
} as const;

export type Palette = typeof palette;
